import { render, staticRenderFns } from "./auto-renewal.vue?vue&type=template&id=4543a890&"
import script from "./auto-renewal.vue?vue&type=script&lang=js&"
export * from "./auto-renewal.vue?vue&type=script&lang=js&"
import style0 from "./auto-renewal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4543a890')) {
      api.createRecord('4543a890', component.options)
    } else {
      api.reload('4543a890', component.options)
    }
    module.hot.accept("./auto-renewal.vue?vue&type=template&id=4543a890&", function () {
      api.rerender('4543a890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/account/auto-renewal/auto-renewal.vue"
export default component.exports